// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

require("jquery");
require("popper.js");
require("sweetalert2");
require("packs/flatpickr")
require("packs/flatpickr_fr")

require("jquery-validation");
require("packs/jquery.dataTables.min")
require("packs/dataTables.bootstrap")
require("packs/dataTables.responsive")
require("packs/availability-calendar")
require("js-loading-overlay")
require("packs/calendar");
require("packs/interact.min")
require("packs/jquery.scrollbar.min");
require("packs/snippets")
require("packs/app/registration");
require("packs/app/calendar");
require("packs/app/appointments");
require("packs/app/services");
require("packs/app/users");
require("packs/app/workshops")
require("packs/app/client");
require("packs/app/notifications");
require("packs/app/clients");
require("packs/app/profile");
require("packs/app/dashboard");
require("packs/app/announcements");
require("pluralize")
require("packs/jquery.validate.min")
require("packs/table.min.js")
require("packs/select2.full.min")
require('packs/rater-js')
require("packs/jquery.mask.min")
require("packs/jquery.maskedinput")
require("packs/bootstrap-datepicker")
require("packs/datepicker")
require("packs/loadingoverlay.min")
require("packs/fontawesome.min")

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import Swal from 'sweetalert2';
window.Swal = Swal;

import interact from 'packs/interact.min';
window.interact = interact;

import Pluralize from 'pluralize';
window.Pluralize = Pluralize;

moment.locale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er|e)/,
    ordinal : function (number) {
        return number + (number === 1 ? 'er' : 'e');
    },
    meridiemParse : /PD|MD/,
    isPM : function (input) {
        return input.charAt(0) === 'M';
    },
    // In case the meridiem units are not separated around 12, then implement
    // this function (look at locale/id.js for an example).
    // meridiemHour : function (hour, meridiem) {
    //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
    // },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // Used to determine first week of the year.
    }
});

moment.locale("fr")

$( document ).ready(function() {

    let modal_announcement

    if (document.getElementById("modal-announcement") != null) {
        modal_announcement = new bootstrap.Modal(document.getElementById("modal-announcement"), {backdrop: 'static', keyboard: false});
    }

    if ($("#announcement-popup").length > 0) {
        let announcement_id = $("#announcement-popup").attr('data-id')

        getAnnouncement(announcement_id)
    }

    $(document).on("click", "#btn-close-announcement", function() {
        fetch(`/announcements/close`, {
            method: 'PUT',
            mode: 'cors',
            cache: 'default',
        }).then(function(response) {
            response.json().then(function(data) {

                modal_announcement.hide()
            })
        });
    })

    function getAnnouncement(announcement_id) {
    
        fetch(`/announcements/${announcement_id}`, {
            method: 'GET',
            mode: 'cors',
            cache: 'default',
        }).then(function(response) {
            response.json().then(function(data) {
                $(".announcement-title").text(data.title)
                if (data.image.url != null) {
                    $(".announcement-image-content").removeClass("d-none")
                    $(".announcement-image").css(`background-image` , `url('${data.image.url}')`)
                }
                else {
                    $(".announcement-image-content").addClass("d-none")
                }

                $(".announcement-content").text(data.content)

                modal_announcement.show()
            })

        });
    }

})



$(document).keydown(function(e) {
    if (e.keyCode == 122) {

        window.matchMedia('(display-mode: fullscreen)').addEventListener('change', ({ matches }) => {
        if (matches) {
            $(".sav-header").addClass("d-none")
            window.isFullScreen=true;
        } else {
            window.isFullScreen=false;
             $(".sav-header").removeClass("d-none")
        }
    });
    }
});

